import { WSInfoBox, WSProgressBar } from "@wingspanhq/fe-component-library";
import {
  SharedFileRequestJob,
  SharedFileRequestJobStatus,
  SharedFileRequestJobType
} from "@wingspanhq/wingspan-api-sdk";
import React from "react";

// `type` is widened for the same reason as `ValidationItemProps.type`: besides
// shared-file jobs this also counts insurance-import jobs, whose kind is not a
// `SharedFileRequestJobType` member even though it shares its wire values
type Job = Pick<SharedFileRequestJob, "status"> & {
  type?: string;
};

export const ValidationProgress: React.FC<{
  jobs?: Job[];
  isBackgroundValidation?: boolean;
}> = ({ jobs, isBackgroundValidation = true }) => {
  const validations = jobs?.filter(
    job => job.type === SharedFileRequestJobType.VALIDATION
  );

  if (!validations?.length) {
    return null;
  }

  const finished = validations.filter(
    job =>
      job.status === SharedFileRequestJobStatus.COMPLETE ||
      job.status === SharedFileRequestJobStatus.FAILED ||
      job.status === SharedFileRequestJobStatus.ERROR
  );

  const allLength = validations.length;
  const finishedLength = finished.length;

  const percent = Math.round((finishedLength / allLength) * 100);

  const description =
    finishedLength === allLength
      ? "All validations completed. Finalizing..."
      : finishedLength === 0
        ? "Pending, validation will begin shortly..."
        : `${finishedLength} of ${allLength} validations checked. ${
            isBackgroundValidation
              ? "If you close this page, the progress will continue until it is completed."
              : ""
          }`;
  const descriptionIcon =
    finishedLength === 0 || finishedLength === allLength ? "loader" : "time";

  return (
    <WSProgressBar
      percent={percent}
      text={
        <WSInfoBox
          icon={descriptionIcon}
          iconColor="blue400"
          mt="S"
          theme="neutral"
          transparent
        >
          {description}
        </WSInfoBox>
      }
    />
  );
};
